import React from 'react'
import dimensionsList from 'utils/dimensions'

function getDimensionIcon(dimension, item) {
  if (dimension === 'channel') return `channel-${item}`

  if (dimension === 'channelGroup') {
    return (
      <div className={`filter-channel-group is-${item}`} />
    )
  }

  return `${dimension}-${item}`
}

export function getAvailableDimensions(availableDimensions, sites) {
  if (!availableDimensions) return null

  return Object.keys(availableDimensions).reduce((acc, dimension) => {
    const dimensions = availableDimensions[dimension]
    let {format} = dimensionsList.find(d => d.id === dimension)

    acc[dimension] = dimensions.map(item => ({
      id: item,
      value: item,
      icon: getDimensionIcon(dimension, item),
      label: format(item, sites)
    }))
    return acc
  }, {})
}

export function getLoadingAnalytics(state) {
  const {analytics} = state
  return analytics.loading || false
}



// WEBPACK FOOTER //
// ./client/redux/modules/analytics/selectors.js